function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import Icon, { IconButton } from "@xo-union/tk-component-icons";
import { Button, Link } from "@xo-union/tk-component-buttons";
import { useUniqueID } from "@xo-union/react-unique-id";
import styles from "./styles.css";
import ScreenReaderPrefix from "../ScreenReaderPrefix.js";
var defaultIconNames = {
  error: 'error',
  info: 'info',
  success: 'checkmark_circle',
  warning: 'warning'
};
var defaultIconRender = function defaultIconRender(props) {
  return /*#__PURE__*/React.createElement(Icon, props);
};
export var InlineAlertCtaButton = function InlineAlertCtaButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    color: "primary-alternative",
    size: "sm"
  }));
};
export var InlineAlertCtaLink = function InlineAlertCtaLink(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    color: "primary-alternative",
    size: "sm"
  }), children);
};
export var InlineAlert = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var ariaLive = _ref2['aria-live'],
    children = _ref2.children,
    classesProp = _ref2.classes,
    className = _ref2.className,
    cta = _ref2.cta,
    headline = _ref2.headline,
    headlineId = _ref2.headlineId,
    icon = _ref2.icon,
    id = _ref2.id,
    onCloseButtonClick = _ref2.onCloseButtonClick,
    givenRole = _ref2.role,
    type = _ref2.type,
    visible = _ref2.visible;
  var classes = useClasses(styles, classesProp);
  var visibility = visible ? 'is-visible' : 'is-not-visible';
  var visibleClass = classes[visibility] || '';
  var role = visible ? givenRole : 'none';
  var live = visible && role !== 'none' ? ariaLive : 'off';
  var ariaHidden = !visible;
  var visibleCloseButton = onCloseButtonClick !== undefined && type !== 'error';
  var defaultIconName = defaultIconNames[type];
  var iconProps = {
    'aria-hidden': 'true',
    className: cx(classes['alert-icon'], classes["icon-".concat(type)]),
    size: 'md'
  };
  var uniqueHeadlineId = useUniqueID(headlineId);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, classes[type], className, visibleClass),
    role: "group",
    "aria-labelledby": uniqueHeadlineId,
    "aria-hidden": ariaHidden,
    "aria-roledescription": "alert",
    ref: ref,
    id: id
  }, icon !== false && (typeof icon === 'function' ? icon(_objectSpread(_objectSpread({}, iconProps), {}, {
    name: defaultIconName
  })) : defaultIconRender(_objectSpread(_objectSpread({}, iconProps), {}, {
    name: icon || defaultIconName
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes['text-container'],
    role: role,
    "aria-live": live
  }, headline ? /*#__PURE__*/React.createElement("div", {
    role: "heading",
    "aria-level": "1",
    className: classes['alert-headline'],
    id: uniqueHeadlineId
  }, /*#__PURE__*/React.createElement(ScreenReaderPrefix, {
    type: type
  }), headline) : /*#__PURE__*/React.createElement(ScreenReaderPrefix, {
    id: uniqueHeadlineId,
    type: type
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.children
  }, children), cta && /*#__PURE__*/React.createElement("div", {
    className: classes['alert-cta-container']
  }, cta)), visibleCloseButton && /*#__PURE__*/React.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    className: classes['close-button'],
    name: "close",
    onClick: onCloseButtonClick,
    size: "md"
  })));
});
process.env.NODE_ENV !== "production" ? InlineAlertCtaLink.propTypes = {
  /**
   * Contents of CTA Link
   */
  children: PropTypes.node.isRequired
} : void 0;
process.env.NODE_ENV !== "production" ? InlineAlert.propTypes = {
  /**
   * The aria-live setting for the component
   */
  'aria-live': PropTypes.string,
  /**
   * Contents of alert
   */
  children: PropTypes.node.isRequired,
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'children', 'alert-icon', 'text-container']),
  /**
   * Additional class to append to inline alert container
   */
  className: PropTypes.string,
  /**
   * CTA; pass in either an `InlineAlertCtaButton` or `InlineAlertCtaLink`, which accept all of the props that `@xo-union/tk-component-buttons`'s `Button` and `Link` components accept, respectively.
   */
  cta: PropTypes.node,
  /**
   * Optional headline for the alert
   */
  headline: PropTypes.string,
  /**
   * id of the alert headline (useful if you see warnings about duplicate ids)
   */
  headlineId: PropTypes.string,
  /**
   * Use a custom icon name from tk-component-icons instead of the built in (info, warning, error) icons
   *
   * You can omit the icon by passing `false`
   * You can also use a render function to override the rendering all together
   */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.oneOf([false])]),
  /**
   * ID of the alert component
   */
  id: PropTypes.string,
  /**
   * Adds an "X"/close button to the alert and gets called when the button is clicked. Note: this prop does nothing when `type="error` because close buttons are disallowed for "error" alerts
   */
  onCloseButtonClick: PropTypes.func,
  /**
   * The aria role for the component. Setting role="none" makes it so screen readers do not immediately read the alert after page load since this alert is static
   */
  role: PropTypes.string,
  /**
   * Select the type of alert to display
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
  /**
   * Should the alert be visible
   */
  visible: PropTypes.bool
} : void 0;
InlineAlert.defaultProps = {
  'aria-live': 'polite',
  role: 'alert',
  visible: true
};